import { useFormState } from 'react-final-form';
import { FlexflowEmployeeStatuses } from '../../../../types';
import { type FlexflowEmployeeDataToDisplay } from '../../../../Contracts/types';
import CardGroup from '../../../CardGroup';
import { SuspendedBanner } from '../../../SuspendedBanner';

type GeneralTabProps = {
  isSuspendedBannerVisible: boolean;
  suspendedByLimit: boolean;
};

export const GeneralTab = ({ isSuspendedBannerVisible, suspendedByLimit }: GeneralTabProps) => {
  const { values } = useFormState();

  return (
    <>
      {isSuspendedBannerVisible && (
        <SuspendedBanner data={values as FlexflowEmployeeDataToDisplay} suspendedByLimit={suspendedByLimit} />
      )}
      <CardGroup
        payflowStatus={values?.status}
        data={values?.card}
        payflowUserId={values.payflowUserId}
        notInvited={values?.status === FlexflowEmployeeStatuses.NOT_ENABLED}
        employeeDisabled={values?.status === FlexflowEmployeeStatuses.DISABLED}
      />
    </>
  );
};
